<div *transloco="let t" class="empty-panel d-flex flex-column align-items-center w-100 my-auto"
    [ngClass]="{'empty-panel': emptyPanelStyle}" [ngStyle]="{'padding': customPadding}">
    <app-material-icon [size]=75 class="text-muted" *ngIf="icon">{{icon}}</app-material-icon>
    <p class="empty-message text-muted text-center m-2">{{t(emptyMessage)}}</p>
    <button *ngIf="isAddItemUsed && showBtn" (click)="add()" class="btn btn-gray">
        <app-material-icon>add</app-material-icon>
        {{t(btnTxt)}}
    </button>
</div>